import React from 'react';
import PropTypes from 'prop-types';
import OrgPatientListStore from "../Modals/PrintModal/store/OrgPatientListStore";
import PrintModal from "../Modals/PrintModal/PrintModal";
import OrgPage from "../OrgPage";
import {observer} from "mobx-react";
import TextCell from "../Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {useParams} from "react-router-dom";

import CustomPrintModalStore from "../Modals/CustomPrintModal/store/CustomPrintModalStore";
import CustomPrintModal from "../Modals/CustomPrintModal/CustomPrintModal";


const PatientListPageTemplate = observer((props) => {
    const baseURL = process.env.REACT_APP_BASE_URL
    const {historyId} = useParams()
    return (<>
            {OrgPatientListStore.printModal.show
                ? <PrintModal/>
                : ''}
            {CustomPrintModalStore.printModal.show
                ? <CustomPrintModal/>
                : ''}


            <OrgPage
                url={`${baseURL}${props.getPatientURL}`}
                firstRow={props.tableModel.firstRow}
                refresh={props.refresh}
                haveToShow={props.tableModel.haveToShow}
                breadCrumbsItems={props.breadCrumbsItems}
                defaultSortBy={{name: 'result_date', method: true, ready: ''}}
                exportTemplateButtons={
                    {
                        export: props.export,
                        registry: props.registry,
						printall: props.printall,
                        exportUrl: `/api/v2/general/export/excel?${historyId ? ("historyId=" + historyId + "&") : ""}`,
                        registryUrl: `/api/v2/general/export/registry?${historyId ? ("historyId=" + historyId + "&") : ""}`,
                        printUrl: `/api/v2/general/export/pdf2?${historyId ? ("historyId=" + historyId + "&") : ""}`,
                    }
                }
                filterBarButtons={{
                    downloadTemplate: {
                        show: false,
                        url: '/'
                    }
                }}
                filterFieldsConf={props.filterFieldsConf ? props.filterFieldsConf : {
                    fio: true,
                    date: true,
                    period: true,
                    org: true,
                    place: true,
                    medBook: true,
                    center: true,
                    result: true,
                    base: true

                }}
            />


        </>
    );

})

export default PatientListPageTemplate;

PatientListPageTemplate.propTypes = {
    breadCrumbsItems: PropTypes.array,
    getPatientURL: PropTypes.string,
    exportUrl: PropTypes.string,
    registry: PropTypes.any,
    tableModel: PropTypes.object
}


PatientListPageTemplate.defaultProps = {
    exportUrl: '/api/v1/organizations/patients/export/excel?',
    registryUrl: '/api/v1/organizations/patients/export/excel/registry?',
    registry: true,
    export: true,
    tableModel: {
        firstRow: [
            {title: 'ФИО', id: 'fio'},
            {title: 'Мед. книжка', id: 'medBook'},
            {title: 'Дата рождения', id: 'dob'},
            {title: 'Организация', id: 'organization'},
            {title: 'Дата прохождения', id: 'resultDate'},
            {title: 'Мед центр', id: 'medCenter'},
            {title: 'Результат', id: 'result'},
            {title: 'Распечатать', id: ''}],
        haveToShow: [
            {
                id: 'patient', type: 'wrapperCell', typeData: {
                    cell: props =>
                        <TextCell text={props.all.patient.fio}/>
                }
            },
            {id: 'patient', type: 'arrCell', typeData: {show: 'medBook', id: 'patientId'}},
            {id: 'patient', type: 'arrCell', typeData: {show: 'dob', id: 'patientId'}},
            {id: 'organization', type: 'arrCell', typeData: {show: 'name', id: 'organizationId'}},
            {id: 'results', type: 'arrCell', typeData: {show: 'resultDate', id: 'patientId'}},
            {id: 'medCenter', type: 'arrCell', typeData: {show: 'name', id: 'organizationId'}},
            {id: 'results', type: 'resultStatusCell', typeData: {show: 'result', id: 'patientId'}},
            {
                id: 'results',
                idArr: ['_id'],
                typeData: {
                    onClick: (patientId, resultId) => OrgPatientListStore.showPrintModal(resultId, patientId),
                    prop1: 'patientId'
                },
                type: 'printModalCell'
            },
        ]

    }
}
